import { useCallback, useEffect, useState, useRef } from "react";
import {
  AssociateModalSubTitle,
  AssociateModalTitle,
  AssocieteAndTransferModal,
  AssocieteModalHeader,
  ButtonAssociateModal,
  ButtonCancelModal,
  CredentialsCardButtonAssociate,
  CredentialsCardButtonsContainer,
  CredentialsCardButtonTransfer,
  CredentialsCardContainer,
  CredentialsCardContent,
  CredentialsCardSubTitle,
  CredentialsCardTitle,
  SelectCustom,
  TransferCauntion,
} from "../../styles";
import { useWatch } from "antd/lib/form/Form";
import { useIntl } from "react-intl";
import { Modal, notification, Select, Spin } from "antd";
import api from "../../../../service";
import { useSelector } from "react-redux";
import { Form } from "antd";
import { useHistory } from "react-router-dom";
import { IoInformationCircle } from "react-icons/io5";
import ModalNewCollaborator from "../../../../components/ModalNewCollaborator";
import ModalAssociateSuccess from "../../../../components/ModalAssociateSuccess";
import { CustomButton } from "../../Services/Credentials/styles";
import { base64ToArrayBuffer, mergePdfs } from "../../../../utils/file";
import printJS from "print-js";
import generateHeaders from "../../../../utils/generateHeaders";

// ============ CONSTANTES ============
const REQUEST_TIMEOUT_MS = 60000; // 60 segundos timeout
const DEBOUNCE_DELAY_MS = 500; // 500ms para debounce

export default function CredentialsCard({
  type,
  associateQuantity,
  transferQuantity,
  needAcquire,
  isModalVisible,
  isModalVisibleTransfer,
  modalType,
  onOpenModal,
  onCloseModal,
  icon,
  noTransfer,
  modalIcon,
  onOpenModalTransfer,
  onCloseModalTransfer,
  selectedQuantity,
  credential,
  onPrintedNow,
  onPrintLater,
}) {
  const [form] = Form.useForm();
  const intl = useIntl();
  const { Option } = Select;
  const [employee, setEmployee] = useState([]);
  const { token } = useSelector((state) => state.auth);
  const serviceEventId = localStorage.getItem("serviceEventId");
  const serviceOpportunityId = localStorage.getItem("serviceOpportunityId");
  const serviceSystemUserId = localStorage.getItem("serviceSystemUserId");
  const history = useHistory();
  const [benefitedCompanies, setBenefitedCompanies] = useState([]);
  const collaboratorValue = useWatch("collaboratorId", form);
  const benefitedValue = useWatch("benefited", form);
  const quantityValue = useWatch("quantity", form);
  const serviceValue = useWatch("service", form);
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [isServiceProvider, setIsServiceProvider] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [valuesCredentialsPrint, setValuesCredentialsPrint] = useState();
  const [visibleModalPrintConfirm, setVisibleModalPrintConfirm] =
    useState(false);
  const [loadingPrintAssociated, setLoadingPrintAssociated] = useState(false);

  // ✅ Estados para controlar múltiplos cliques
  const [isProcessing, setIsProcessing] = useState(false);
  const [isTransferProcessing, setIsTransferProcessing] = useState(false);
  const associateAbortControllerRef = useRef(null);
  const transferAbortControllerRef = useRef(null);

  /**
   * Limpa recursos de associação (AbortController)
   */
  const cleanupAssociateRequest = useCallback(() => {
    if (associateAbortControllerRef.current) {
      associateAbortControllerRef.current.abort();
      associateAbortControllerRef.current = null;
    }
  }, []);

  /**
   * Limpa recursos de transferência (AbortController)
   */
  const cleanupTransferRequest = useCallback(() => {
    if (transferAbortControllerRef.current) {
      transferAbortControllerRef.current.abort();
      transferAbortControllerRef.current = null;
    }
  }, []);

  /**
   * Reset de credenciais impressas com cleanup
   */
  function resetCredentialsPrint() {
    cleanupAssociateRequest();
    setVisibleModalPrintConfirm(false);
    setValuesCredentialsPrint(undefined);
    setIsProcessing(false);
    onCloseModal();
    form.resetFields();
  }

  /**
   * Cleanup ao desmontar componente
   */
  useEffect(() => {
    return () => {
      cleanupAssociateRequest();
      cleanupTransferRequest();
    };
  }, [cleanupAssociateRequest, cleanupTransferRequest]);

  // INFORMACP-4391 — so busca colaboradores quando o modal deste card abre
  // (evita 1 request por card montado; sao varios cards na tela)
  useEffect(() => {
    if (isModalVisible) {
      fetchEmployee();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);

  useEffect(() => {
    const fetchBenefitedCompanies = async () => {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      };

      try {
        const userResponse = await api.patch(
          `/users/admin-transfer/opportunity`,
          {
            userId: Number(serviceSystemUserId),
            opportunityId: Number(serviceOpportunityId),
          },
          config
        );

        const users = userResponse.data.systemUserByOpportunityOutputs.map(
          (user) => ({
            value: user.id,
            label: user.commercialName,
            isBenefitedServiceProvider: user.serviceProvider,
          })
        );

        setBenefitedCompanies(users);
      } catch (err) {
        console.error("Erro ao buscar empresas beneficiadas:", err);
      }
    };

    if (isModalVisibleTransfer) {
      fetchBenefitedCompanies();
    }
  }, [
    isModalVisibleTransfer,
    token,
    serviceSystemUserId,
    serviceOpportunityId,
  ]);

  /**
   * Busca lista de colaboradores disponíveis
   */
  // INFORMACP-4391 — cacheia colaboradores e evita requisicoes duplicadas
  const [employeeCache, setEmployeeCache] = useState(null);
  const [isFetchingEmployee, setIsFetchingEmployee] = useState(false);

  const fetchEmployee = useCallback(async (forceRefresh = false) => {
    if (employeeCache && !forceRefresh) {
      setEmployee(employeeCache);
      return;
    }
    if (isFetchingEmployee) return;
    setIsFetchingEmployee(true);
    try {
      const result = await api.get(
        `/associate-collaborators/admin-accreditation/by-user/${serviceSystemUserId}?opportunity=${serviceOpportunityId}&credential=0`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const list = result.data?.output || [];
      setEmployee(list);
      setEmployeeCache(list);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: `api.error.${error.response?.data?.description || "unknown"}`,
        }),
      });
    } finally {
      setIsFetchingEmployee(false);
    }
  }, [
    serviceSystemUserId,
    serviceOpportunityId,
    token,
    intl,
    employeeCache,
    isFetchingEmployee,
  ]);

  /**
   * ✅ Associa credencial com proteção contra múltiplos cliques
   * - Desabilita botão imediatamente
   * - Valida dados
   * - Envia requisição com AbortController
   * - Exibe feedback visual
   */
  const handleAssociateCredential = useCallback(async () => {
    // ✅ Proteção: se já está processando, ignora
    if (isProcessing) {
      console.warn("Associação já em processamento, ignorando clique");
      return;
    }

    try {
      setIsProcessing(true);

      // ✅ Validar campos antes de enviar
      const values = await form.validateFields();

      // ✅ Criar novo AbortController para essa requisição
      cleanupAssociateRequest();
      associateAbortControllerRef.current = new AbortController();

      // ✅ Enviar requisição com timeout
      const timeoutId = setTimeout(() => {
        if (associateAbortControllerRef.current) {
          associateAbortControllerRef.current.abort();
        }
      }, REQUEST_TIMEOUT_MS);

      const response = await api.post(
        `accreditation/admin/${serviceSystemUserId}`,
        {
          eventId: serviceEventId,
          opportunityId: Number(serviceOpportunityId),
          associateCollaboratorList: values.collaboratorId,
          credentialType: credential,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      clearTimeout(timeoutId);

      // ✅ Sucesso
      notification.success({
        message: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({
          id: "success.credential_associated!",
        }),
      });

      setValuesCredentialsPrint(values);
    } catch (error) {
      // ✅ Ignorar erros de abort (requisição cancelada)
      if (error.name === "AbortError") {
        notification.warning({
          message: intl.formatMessage({ id: "warning" }),
          description: intl.formatMessage({
            id: "operation_cancelled",
          }),
        });
        return;
      }

      const errorCode = error.response?.data?.code;
      const errorDescription = error.response?.data?.description;

      // ✅ Tratamento específico de erros
      if (errorCode === -13012) {
        notification.warning({
          message: intl.formatMessage({ id: "warning" }),
          description: intl.formatMessage({
            id: "api.error.-13012",
          }),
        });
      } else if (errorCode === -13010) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error.-13010",
          }),
        });
      } else if (errorCode === -13032) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error.-13033",
          }),
        });
      } else if (errorCode === -13033) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error.-13033",
          }),
        });
      } else {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: `api.error.${errorDescription || "unknown"}`,
          }),
        });
      }

      // ✅ Em caso de erro, não fecha o modal para permitir retry
      setIsProcessing(false);
    } finally {
      cleanupAssociateRequest();
    }
  }, [
    isProcessing,
    form,
    serviceSystemUserId,
    serviceEventId,
    serviceOpportunityId,
    credential,
    token,
    intl,
    cleanupAssociateRequest,
  ]);

  /**
   * ✅ Transfere credencial com proteção contra múltiplos cliques
   */
  const handleTransferCredential = useCallback(async () => {
    // ✅ Proteção: se já está processando, ignora
    if (isTransferProcessing) {
      console.warn("Transferência já em processamento, ignorando clique");
      return;
    }

    try {
      setIsTransferProcessing(true);

      // ✅ Validar campos antes de enviar
      const values = await form.validateFields();

      // ✅ Criar novo AbortController para essa requisição
      cleanupTransferRequest();
      transferAbortControllerRef.current = new AbortController();

      // ✅ Enviar requisição com timeout
      const timeoutId = setTimeout(() => {
        if (transferAbortControllerRef.current) {
          transferAbortControllerRef.current.abort();
        }
      }, REQUEST_TIMEOUT_MS);

      const response = await api.post(
        `admin-credential-transfer`,
        {
          opportunityId: Number(serviceOpportunityId),
          transferorId: Number(serviceSystemUserId),
          quantity: String(values.quantity),
          benefitedId: values.benefited,
          credentialType: credential,
          serviceProviderAssociationId: values.service,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      clearTimeout(timeoutId);

      // ✅ Sucesso
      notification.success({
        message: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({
          id: "success.credential_transfer!",
        }),
      });

      // ✅ Fechar modal e limpar após sucesso
      setIsTransferProcessing(false);
      onCloseModalTransfer();
      form.resetFields();
    } catch (error) {
      // ✅ Ignorar erros de abort (requisição cancelada)
      if (error.name === "AbortError") {
        notification.warning({
          message: intl.formatMessage({ id: "warning" }),
          description: intl.formatMessage({
            id: "operation_cancelled",
          }),
        });
        setIsTransferProcessing(false);
        return;
      }

      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: `api.error.${error.response?.data?.code || "unknown"}`,
        }),
      });

      // ✅ Em caso de erro, permanece processando para retry
      setIsTransferProcessing(false);
    } finally {
      cleanupTransferRequest();
    }
  }, [
    isTransferProcessing,
    form,
    serviceOpportunityId,
    serviceSystemUserId,
    credential,
    token,
    intl,
    onCloseModalTransfer,
    cleanupTransferRequest,
  ]);

  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const response = await api.patch(
          `/provider-association/find-services`,
          {
            opportunityId: Number(serviceOpportunityId),
            systemUserBenefitedId: benefitedValue,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setServices(response.data.output);
      } catch (err) {
        console.error("Erro ao buscar serviços:", err);
      } finally {
        setLoading(false);
      }
    };

    if (benefitedValue) {
      fetchServices();
    }
  }, [benefitedValue, serviceOpportunityId, token]);

  /**
   * Busca e imprime credenciais associadas
   * @param {Object} values - Valores do formulário
   */
  async function getPrintAssociated(values) {
    try {
      setLoadingPrintAssociated(true);
      const options = generateHeaders(token);

      const result = await api.patch(
        `/admin/accreditation/`,
        {
          eventId: serviceEventId,
          systemUserId: serviceSystemUserId,
          opportunityId: serviceOpportunityId,
          isPrinted: false,
          withdrawn: false,
        },
        options
      );

      const responseAssociate =
        result?.data?.credentialAdminOutputList || undefined;

      if (!responseAssociate) return;

      const collaborator = responseAssociate.find(
        (associated) => associated.collaboratorId === values.collaboratorId[0]
      );

      const targetCredentialsIds = responseAssociate
        .filter((item) => values.collaboratorId.includes(item.collaboratorId))
        .map((item) => item.id);

      const sanitizedValues = JSON.stringify({
        phone: `+55 `,
        email: undefined,
        name: undefined,
        credentialCompanyName: collaborator.companyName || "",
        credentialIds: targetCredentialsIds,
        eventId: localStorage.getItem("serviceEventId"),
        opportunityId: localStorage.getItem("serviceOpportunityId"),
        userId: localStorage.getItem("serviceSystemUserId"),
        printCredential: true,
        withdrawCredential: false,
      });

      const response = await api.post(
        "/credential-reports/staff-withdraw",
        sanitizedValues,
        options
      );

      const credentialReports = response.data?.credentialReports || [];

      if (credentialReports.length > 0) {
        let arrayBuffers = credentialReports.map((apiResult) => {
          return base64ToArrayBuffer(apiResult.file);
        });

        const base64String = btoa(
          [].reduce.call(
            new Uint8Array(await mergePdfs(arrayBuffers)),
            function (p, c) {
              return p + String.fromCharCode(c);
            },
            ""
          )
        );

        printJS({
          printable: base64String,
          type: "pdf",
          base64: true,
        });
      }

      // recem-impressas destacadas/pre-selecionadas (referencia para gerar o protocolo).
      if (onPrintedNow) onPrintedNow(targetCredentialsIds);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: `api.error.${error.response?.data?.description || "unknown"}`,
        }),
      });
    } finally {
      setLoadingPrintAssociated(false);
      resetCredentialsPrint();
    }
  }

  useEffect(() => {
    if (valuesCredentialsPrint) setVisibleModalPrintConfirm(true);
  }, [valuesCredentialsPrint]);

  function handlePrintAssociated() {
    getPrintAssociated(valuesCredentialsPrint);
  }

  function handleCancelPrintAssociated() {
    resetCredentialsPrint();
    // "Imprimir depois": direciona o atendente para a aba Associadas.
    if (onPrintLater) onPrintLater();
  }

  return (
    <>
      <ModalNewCollaborator
        visible={modalVisible}
        setModalVisible={setModalVisible}
        fetchData={() => fetchEmployee(true)}
        notDisplaySuccessModal={true}
        isServiceProvider={
          localStorage.getItem("serviceRoleType") === "SERVICE_PROVIDER"
        }
      />

      {/* ✅ MODAL DE ASSOCIAÇÃO COM LOADING */}
      <Spin
        spinning={isProcessing}
        tip={intl.formatMessage({ id: "processing" })}
      >
        <AssocieteAndTransferModal
          closable={!isProcessing}
          maskClosable={!isProcessing}
          visible={isModalVisible}
          destroyOnClose={true}
          width={658}
          onCancel={() => {
            if (isProcessing) return;
            form.resetFields();
            onCloseModal();
          }}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingBottom: "30px",
              }}
            >
              <ButtonCancelModal
                disabled={isProcessing}
                onClick={() => {
                  form.resetFields();
                  onCloseModal();
                }}
              >
                {intl.formatMessage({ id: "cancel" })}
              </ButtonCancelModal>
              <ButtonAssociateModal
                disabled={
                  !collaboratorValue ||
                  collaboratorValue.length === 0 ||
                  isProcessing
                }
                loading={isProcessing}
                onClick={() => handleAssociateCredential()}
              >
                {isProcessing
                  ? intl.formatMessage({ id: "processing" })
                  : intl.formatMessage({ id: "associate_credential" })}
              </ButtonAssociateModal>
            </div>
          }
        >
          <AssocieteModalHeader>
            <AssociateModalTitle>
              <img
                style={{ marginRight: "10px" }}
                src={modalIcon}
                alt="Credential icon"
              />
              {`${intl.formatMessage({
                id: "credential_of",
              })} ${modalType}`}
            </AssociateModalTitle>
            <CustomButton
              disabled={isProcessing}
              onClick={() => setModalVisible(true)}
            >
              {intl.formatMessage({ id: "new_collaborator" })}
            </CustomButton>
          </AssocieteModalHeader>
          <AssociateModalSubTitle>
            {intl.formatMessage({ id: "select_collaborator" })}
          </AssociateModalSubTitle>
          <Form form={form} layout="vertical">
            <Form.Item style={{ marginBottom: 0 }} name="collaboratorId">
              <SelectCustom
                disabled={isProcessing}
                showSearch
                mode="multiple"
                filterOption={(input, option) => {
                  try {
                    const normalize = (value) =>
                      (value ?? "")
                        .toString()
                        .toLowerCase()
                        .replace(/[.\-/\s]/g, "");
                    const optionText = normalize(
                      option?.label?.toString() ||
                        option?.children?.toString() ||
                        ""
                    );
                    return optionText.includes(normalize(input));
                  } catch (error) {
                    console.error("Erro no filtro de colaborador:", error);
                    return false;
                  }
                }}
                placeholder={intl.formatMessage({ id: "select" })}
                options={(employee || []).map((collab) => ({
                  label: collab.label,
                  value: collab.value,
                }))}
              />
            </Form.Item>
          </Form>
        </AssocieteAndTransferModal>
      </Spin>

      {/* ✅ MODAL DE TRANSFERÊNCIA COM LOADING */}
      <Spin
        spinning={isTransferProcessing}
        tip={intl.formatMessage({ id: "processing" })}
      >
        <AssocieteAndTransferModal
          closable={!isTransferProcessing}
          maskClosable={!isTransferProcessing}
          visible={isModalVisibleTransfer}
          width={658}
          onCancel={() => {
            if (isTransferProcessing) return;
            onCloseModalTransfer();
            form.resetFields();
            setIsServiceProvider(false);
          }}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingBottom: "30px",
              }}
            >
              <ButtonCancelModal
                disabled={isTransferProcessing}
                onClick={() => {
                  onCloseModalTransfer();
                  form.resetFields();
                  setIsServiceProvider(false);
                }}
              >
                {intl.formatMessage({ id: "cancel" })}
              </ButtonCancelModal>
              <ButtonAssociateModal
                disabled={
                  isServiceProvider
                    ? !benefitedValue ||
                      !quantityValue ||
                      !serviceValue ||
                      isTransferProcessing
                    : !benefitedValue || !quantityValue || isTransferProcessing
                }
                loading={isTransferProcessing}
                onClick={() => handleTransferCredential()}
              >
                {isTransferProcessing
                  ? intl.formatMessage({ id: "processing" })
                  : intl.formatMessage({ id: "transfer_credential" })}
              </ButtonAssociateModal>
            </div>
          }
        >
          <div style={{ display: "flex" }}>
            <img src={modalIcon} alt="Credential icon" />
            <AssociateModalTitle>{`${intl.formatMessage({
              id: "transfer_credential_of",
            })} ${modalType}`}</AssociateModalTitle>
          </div>

          <Form style={{ marginTop: "15px" }} form={form} layout="vertical">
            <AssociateModalSubTitle>
              {intl.formatMessage({ id: "select_beneficiary_company" })}
            </AssociateModalSubTitle>

            <Form.Item style={{ marginBottom: 0 }} name="benefited">
              <SelectCustom
                showSearch
                filterOption={(input, option) => {
                  try {
                    const optionText =
                      option?.children?.toString() ||
                      option?.label?.toString() ||
                      "";
                    return optionText
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  } catch (error) {
                    console.error("Error in benefited filterOption:", error);
                    return false;
                  }
                }}
                onChange={(value) => {
                  form.setFieldValue("benefited", value);
                  const selectedCompany = benefitedCompanies.find(
                    (option) => option.value === value
                  );
                  if (selectedCompany) {
                    setIsServiceProvider(
                      selectedCompany.isBenefitedServiceProvider
                    );
                  }
                }}
                placeholder={intl.formatMessage({ id: "select" })}
              >
                {(benefitedCompanies || []).map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </SelectCustom>
              <TransferCauntion>
                <IoInformationCircle style={{ fontSize: "25px" }} />
                {intl.formatMessage({ id: "transfer_cauntion" })}
              </TransferCauntion>
            </Form.Item>
            {isServiceProvider ? (
              <>
                <AssociateModalSubTitle>
                  {intl.formatMessage({ id: "service_type" })}
                </AssociateModalSubTitle>
                <Form.Item style={{ marginBottom: 0 }} name="service">
                  <SelectCustom
                    showSearch
                    filterOption={(input, option) => {
                      try {
                        const optionText =
                          option?.children?.toString() ||
                          option?.label?.toString() ||
                          "";
                        return optionText
                          .toLowerCase()
                          .includes(input.toLowerCase());
                      } catch (error) {
                        console.error("Error in service filterOption:", error);
                        return false;
                      }
                    }}
                    loading={loading}
                    onChange={(value) => {
                      form.setFieldValue("service", value);
                    }}
                    placeholder={intl.formatMessage({ id: "select" })}
                  >
                    {(services || []).map((option) => (
                      <Option
                        key={option.serviceProviderAssociationId}
                        value={option.serviceProviderAssociationId}
                      >
                        {option.serviceTypeName}
                      </Option>
                    ))}
                  </SelectCustom>
                </Form.Item>
              </>
            ) : null}

            <AssociateModalSubTitle style={{ marginTop: "15px" }}>
              {intl.formatMessage({ id: "quantity" })}
            </AssociateModalSubTitle>

            <Form.Item style={{ marginBottom: 0 }} name="quantity">
              <SelectCustom
                disabled={isTransferProcessing}
                showSearch
                filterOption={(input, option) => {
                  try {
                    const optionText =
                      option?.children?.toString() ||
                      option?.label?.toString() ||
                      "";
                    return optionText
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  } catch (error) {
                    console.error("Erro no filtro de quantidade:", error);
                    return false;
                  }
                }}
                placeholder={intl.formatMessage({ id: "select" })}
              >
                {Array.from({ length: selectedQuantity || 0 }, (_, i) => (
                  <Option key={i + 1} value={i + 1}>
                    {i + 1}
                  </Option>
                ))}
              </SelectCustom>
            </Form.Item>
          </Form>
        </AssocieteAndTransferModal>
      </Spin>

      <CredentialsCardContainer>
        <CredentialsCardContent>
          <img src={icon} alt="Credential type icon" />
          <CredentialsCardTitle>{`${intl.formatMessage({
            id: "credential_",
          })} ${type}`}</CredentialsCardTitle>
          <CredentialsCardSubTitle>
            {intl.formatMessage(
              { id: "quantity_associate_transfer" },
              { associate: associateQuantity, transfer: transferQuantity }
            )}
          </CredentialsCardSubTitle>
        </CredentialsCardContent>

        <CredentialsCardButtonsContainer>
          {needAcquire === false ? (
            <>
              {noTransfer === true ? null : (
                <CredentialsCardButtonTransfer
                  disabled={isProcessing || isTransferProcessing}
                  onClick={() => onOpenModalTransfer()}
                >
                  {intl.formatMessage({ id: "transfer" })}
                </CredentialsCardButtonTransfer>
              )}
              <CredentialsCardButtonAssociate
                disabled={isProcessing || isTransferProcessing}
                onClick={() => onOpenModal()}
              >
                {intl.formatMessage({ id: "associate" })}
              </CredentialsCardButtonAssociate>
            </>
          ) : (
            <CredentialsCardButtonAssociate
              onClick={() =>
                history.push("/staff-access/services/sales", {
                  credentialType: credential,
                })
              }
              style={{ width: "171px" }}
            >
              {intl.formatMessage({ id: "acquire_credential" })}
            </CredentialsCardButtonAssociate>
          )}
        </CredentialsCardButtonsContainer>
      </CredentialsCardContainer>

      <ModalAssociateSuccess
        visible={visibleModalPrintConfirm}
        onCancel={handleCancelPrintAssociated}
        onConfirm={handlePrintAssociated}
        loadingPrint={loadingPrintAssociated}
      />
    </>
  );
}
